<div class="tt-grid__symbols">
    <span class="tt-grid__symbol" *ngFor="let icon of icons" [ngClass]="icon.icon" [ngStyle]="icon.style"> </span>
</div>
